import Setting from "./Setting";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../Layout/GroupAdminSidebar";
import { useUser } from "../../context/AuthContext";

const SettingsPage = () => {
  const { user } = useUser();
  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      {/* <Unauthorized requiredModule="Settings"> */}
      <Setting />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default SettingsPage;
